import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnChanges, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export interface StoryPhoto { MediaId?: number; AltText?: string; Caption?: string; }
export interface StorySection { photo?: StoryPhoto; html: string; }

/** Keep whole rich-text blocks in reading order while distributing the photos. */
export function partitionStoryBlocks(blocks: string[], photos: StoryPhoto[]): StorySection[] {
  const count = Math.max(1, photos.length);
  return Array.from({ length: count }, (_, index) => ({
    photo: photos[index],
    html: blocks.slice(Math.floor(index * blocks.length / count), Math.floor((index + 1) * blocks.length / count)).join(''),
  }));
}

@Component({ selector: 'app-recipient-story-body', templateUrl: './recipient-story-body.component.html',
  styleUrls: ['./recipient-story-body.component.scss'] })
export class RecipientStoryBodyComponent implements OnChanges {
  @Input() html = '';
  @Input() photos: StoryPhoto[] = [];
  @Input() photoDescription = '';
  sections: StorySection[] = [];
  constructor(@Inject(DOCUMENT) private document: Document, private sanitizer: DomSanitizer) {}
  ngOnChanges(): void {
    // Parse sanitized HTML in an inert template; never split paragraphs, links or lists.
    const template = this.document.createElement('template');
    template.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.html || '') || '';
    const blocks = Array.from(template.content.childNodes).filter(node => node.nodeType !== 8 &&
      (node.nodeType === 1 || !!node.textContent?.trim())).map(node => {
        const wrapper = this.document.createElement('div');
        wrapper.appendChild(node.cloneNode(true));
        return wrapper.innerHTML;
      });
    this.sections = partitionStoryBlocks(blocks, this.photos || []);
  }
}
